/** @format */

import $ from "jquery";
import "jquery-validation";
import "../extra_validators";

let buttonElem = $("[data-submit]");

function validateForm(form) {
    (form as any).validate({
        rules: {
            vrm: {
                required: true,
                vrm: true,
            },
            postcode: {
                required: true,
                postcode: true,
            },
        },
    });
}

function setupListeners(form) {
    buttonElem.on("click", async () => {
        form.submit();
    });

    form.on("submit", event => {
        event.preventDefault();

        if (buttonElem.find(".loader").length) {
            return;
        }

        let savedContent = buttonElem.html();
        buttonElem.html("<div class='loader'></div>");

        if (!(form as any).valid()) {
            buttonElem.html(savedContent);
            return;
        }

        let vrm = $("[id=vrm]").val() as string;
        let postcode = $("[id=postcode]").val() as string;

        window.location.href = `https://www.silverlake.co.uk/scrap-my-car/details/${vrm}/${postcode}`;
    });

    form.on("keydown", (event: KeyboardEvent) => {
        if (event.key == "Enter") {
            form.submit();
        }
    });
}

export function setup(form) {
    validateForm(form);
    setupListeners(form);
}
